module.exports = __webpack_public_path__ + "assets/img/18_1868_big.7c87fe83.jpg";